import React from "react";
import ProductForm from "../components/ProductForm";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

export default function CreateProducts() {
  const navigate = useNavigate();

  const handleSuccess = () => {
    navigate("/dashboard-admin/products"); // redirect after product is added
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <button
          onClick={() => navigate("/dashboard-admin/products")}
          className="text-gray-600 hover:text-gray-900 transition-colors"
          title="Back to Products"
        >
          <FaArrowLeft className="w-5 h-5" />
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Add New Product</h1>
      </div>
      <div className="bg-white shadow-md rounded">
        <ProductForm onSuccess={handleSuccess} />
      </div>
    </div>
  );
}
